import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aeb43b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-grid" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = {
  key: 0,
  style: {"width":"17px","height":"17px","margin-left":"4px"},
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/KoreaIconBorder@3x.png"
}
const _hoisted_5 = {
  key: 1,
  style: {"width":"17px","height":"17px","margin-left":"4px"},
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/ChinaIcon@3x.png"
}
const _hoisted_6 = { class: "brand-item line--2" }
const _hoisted_7 = {
  key: 0,
  class: "list-page"
}

import { Ref, ref, toRef, watch } from 'vue'
import { goodsShopAdd, goodsShopSetting } from '@/apis/usercenter'
import PopBtn from '@/components/common/PopBtn.vue'
import { t } from '@/plugins/i18n'
import { isJA, useRtfix } from '@/store'
import { confirmUnlike } from '@/util/useConfirm'
import { ElMessage } from 'element-plus'
import ShopItem from '@/components/common/ShopItem.vue'
import { useRouter } from 'vue-router'
import { setValue } from '@/views/brand/components/suffix'

interface Item {
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  props: ['pageNum', 'pageSize', 'data', 'loading', 'behaviorChannel', 'type'],
  emits: ['update:pageNum', 'update:pageSize', 'success'],
  setup(__props, { emit }) {

const props = __props


const data = toRef(props, 'data')

const gotoBrand = (v: any) => {
  if (isJA()) {
    location.href = `/choice/brand/${v.brandCode}`
    return
  }
  router.push(useRtfix('BrandDetail', { params: { brand: v.brandId } }))
}

const router = useRouter()
// const texts = ['找相似', '円', '销量', '件'].map(t)

const list: Ref<Item[]> = ref([])
const total: Ref<number> = ref(0)

watch(data, (v) => {
  setValue(v.records)
  list.value = v.records
  v.total && (total.value = v.total)
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.shopCode,
          class: "list-item rel",
          onClick: ($event: any) => (gotoBrand(v))
        }, [
          _createVNode(_component_el_image, {
            src: v.brandMainImg,
            alt: ""
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_3, [
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (v.countryCode === 'KR')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  (v.countryCode === 'CN')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("a", _hoisted_6, _toDisplayString(v.brandName), 1)
          ]),
          _createElementVNode("span", null, _toDisplayString(v.mainCategory?.map((v)=>v.cateName).join(',')), 1)
        ], 8, _hoisted_2))
      }), 128))
    ]),
    (total.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev,pager,next,sizes,jumper",
            currentPage: __props.pageNum,
            "page-size": __props.pageSize,
            total: total.value,
            onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:pageNum', $event))),
            onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (emit('update:pageSize', $event)))
          }, null, 8, ["currentPage", "page-size", "total"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})